import request from '@/utils/request'

let Electronic_waybill_itemApi = {

  /*电子运单检查项目列表*/
  list(data) {
    return request._post('/shop/plus.electronic_waybill_item.Index/index', data);
},
/*添加电子运单检查项目*/
add(data) {
    return request._post('/shop/plus.electronic_waybill_item.Index/add', data);
},
/*修改电子运单检查项目*/
edit(data) {
    return request._post('/shop/plus.electronic_waybill_item.Index/edit', data);
},
/*删除电子运单检查项目*/
del(data) {
    return request._post('/shop/plus.electronic_waybill_item.Index/del', data);
},
/*电子运单检查项目详情*/
detail(data) {
  return request._post('/shop/plus.electronic_waybill_item.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.electronic_waybill_item.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.electronic_waybill_item.Setting/getSetting', data, errorback);
    },
}
export default Electronic_waybill_itemApi;



// WEBPACK FOOTER //
// ./src/api/electronic_waybill_item.js